import { useState } from "react";
import { fetchNotifications, getSortedUniqueNotifications } from "../services/notification-service";
import { hasMoreData } from "../utils/Common";
import ApiService from "../utils/ApiService";

const useNotificationDataLoader = () => {
  const [notificationInitLoader, setNotificationInitLoader] = useState(false);
  const [notficationLoadMoreLoader, setNotificationLoadMoreLoader] =
    useState(false);
  const [notificationListPageNo, setNotificationListPageNo] = useState(1);
  const [notificationRecords, setNotificationRecords] = useState([]);
  const [hasMoreNotifications, setHasMoreNotifications] = useState(false);

  const markAsReadNotification = async (user, notificationId) => {
    const isSuccess = await ApiService.MARK_AS_READ_NOTIFICATION(
      notificationId,
      user.token.token
    );

    if (isSuccess) {
      setNotificationRecords((prevNotifications) =>
        prevNotifications.map((notification) =>
          notification.id === notificationId
            ? { ...notification, isUnread: false } // Create a new object with the updated property
            : notification
        )
      );
    }
  };

  const loadNotificationData = async (
    user,
    restaurantId,
    pageNo = 1,
    isLoadMore = false
  ) => {
    if (isLoadMore) {
      setNotificationListPageNo(++pageNo);
      setNotificationLoadMoreLoader(true);
    } else {
      setNotificationInitLoader(true);
    }

    const result = await fetchNotifications(user, restaurantId, pageNo);

    
    const sortedArr = getSortedUniqueNotifications(notificationRecords, result.records);
    
    setNotificationRecords(sortedArr);
    setHasMoreNotifications(hasMoreData(pageNo, 10, result.total));

    setNotificationLoadMoreLoader(false);
    setNotificationInitLoader(false);
  };

  return {
    notificationInitLoader,
    notficationLoadMoreLoader,
    notificationRecords,
    notificationListPageNo,
    hasMoreNotifications,
    loadNotificationData,
    markAsReadNotification
  };
};

export default useNotificationDataLoader;
